module.exports = __webpack_public_path__ + "static/media/background-pattern-header.28f91950.png";